import clsx from "clsx";

import * as styles from "./styles.module.scss";

export function ImagePlaceholder({ className }: { className?: string }) {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360.96 358.98">
        <text>Image Not Found</text>
      </svg>
    </div>
  );
}
